import { makeAutoObservable } from 'mobx'
import * as apiClient from 'src/utils/apiClient/buildings'

export default class BuildingStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  search = async (params: apiClient.SearchParams) => {
    return await apiClient.search(params)
  }

  searchBuildings = async (keyword: string) => {
    const { buildings } = await apiClient.searchBuildings(keyword)
    return buildings
  }
}
